if (!customElements.get('bb-shipping')) {
  customElements.define('bb-shipping', class extends HTMLElement {
    connectedCallback() {
      this.messages = JSON.parse(this.querySelector('template').innerHTML);
      const info = this.closest('product-info') || document.querySelector(`product-info:has(button[data-product-id="${this.dataset.productId}"])`);
      this.container = info || this.closest('section');
      this.picker = this.container?.querySelector('variant-radios, variant-selects');
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!this.picker || (data.renderedSectionId || data.sectionId) !== this.picker.dataset.section) return;
        if (this.picker.currentVariant?.id !== data.variant?.id) return;
        this.setVariant(data.variant?.id);
      });
      this.onChange = () => this.setVariant(this.picker.currentVariant?.id);
      this.container?.addEventListener('change', this.onChange);
    }
    setVariant(id) {
      this.querySelector('[data-shipping-message]').textContent = this.messages[String(id)] || window.bbPurchaseStrings.pending;
      this.dataset.variantId = id || '';
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.container?.removeEventListener('change', this.onChange);
    }
  });
}
if (!customElements.get('bb-sticky-atc')) {
  customElements.define('bb-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      this.container = this.closest('section');
      this.main = document.getElementById(this.dataset.mainButton);
      if (!this.main || this.closest('quick-add-modal')) return;
      this.proxy = this.querySelector('[data-bb-sticky-button]');
      this.price = this.querySelector('[data-bb-sticky-price]');
      this.shipping = this.querySelector('[data-bb-sticky-shipping]');
      this.picker = this.container.querySelector('variant-radios, variant-selects');
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if ((data.renderedSectionId || data.sectionId) !== this.dataset.section) return;
        this.sync();
      });
      this.onClick = () => {
        this.sync();
        if (this.proxy.disabled || this.inert) return;
        this.main.click();
        this.sync();
      };
      this.proxy.addEventListener('click', this.onClick);
      this.mutation = new MutationObserver(() => this.sync());
      this.mutation.observe(this.main, { attributes: true, childList: true, subtree: true });
      const mainPrice = document.getElementById(`price-${this.dataset.section}`);
      if (mainPrice) this.mutation.observe(mainPrice, { attributes: true, childList: true, subtree: true });
      this.onChange = () => this.sync();
      this.container.addEventListener('change', this.onChange);
      this.viewport = window.matchMedia('(max-width: 989px)');
      this.onViewport = () => this.show(this.offscreen);
      this.viewport.addEventListener('change', this.onViewport);
      this.intersection = new IntersectionObserver(([entry]) => {
        this.offscreen = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.show(this.offscreen);
      });
      this.intersection.observe(this.main);
      this.onScroll = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.offscreen = this.main.getBoundingClientRect().bottom <= 0;
          this.show(this.offscreen);
        });
      };
      window.addEventListener('scroll', this.onScroll, {passive: true});
      this.onScroll();
      this.sync();
    }
    show(offscreen) {
      const visible = Boolean(offscreen && this.viewport.matches);
      this.classList.toggle('bb-sticky-atc--visible', visible);
      this.setAttribute('aria-hidden', String(!visible));
      this.inert = !visible;
      this.proxy.tabIndex = visible ? 0 : -1;
    }
    sync() {
      if (!this.main) return;
      const pending = this.picker?.dataset.pending === 'true';
      const busy = this.main.getAttribute('aria-disabled') === 'true' || this.main.classList.contains('loading');
      this.proxy.disabled = this.main.disabled || pending || busy;
      this.proxy.textContent = pending ? window.bbPurchaseStrings.pending : this.main.querySelector('span').textContent.trim();
      const wrapper = document.getElementById(`price-${this.dataset.section}`);
      const price = wrapper?.querySelector('.price--on-sale .price__sale .price-item--sale') || wrapper?.querySelector('.price__regular .price-item--regular');
      const message = this.container.querySelector('bb-shipping [data-shipping-message]');
      if (this.shipping) this.shipping.textContent = pending ? window.bbPurchaseStrings.pending : (message?.textContent.trim() || '');
      this.price.textContent = pending || wrapper?.classList.contains('visibility-hidden') ? '' : (price?.textContent.trim() || '');
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.intersection?.disconnect();
      this.mutation?.disconnect();
      this.proxy?.removeEventListener('click', this.onClick);
      this.container?.removeEventListener('change', this.onChange);
      this.viewport?.removeEventListener('change', this.onViewport);
      window.removeEventListener('scroll', this.onScroll);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
    }
  });
}

if (!customElements.get('bb-offer-price')) {
  customElements.define('bb-offer-price', class extends HTMLElement {
    connectedCallback() {
      this.info = document.querySelector(`product-info:has(button[data-product-id="${this.dataset.productId}"])`);
      this.picker = this.info?.querySelector('variant-radios, variant-selects');
      this.onChange = () => this.sync(this.picker.currentVariant?.id);
      this.info?.addEventListener('change', this.onChange);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (this.picker && (data.renderedSectionId || data.sectionId) === this.picker.dataset.section) this.sync(this.picker.currentVariant?.id);
      });
    }
    sync(id) {
      const source = this.querySelector(`template[data-variant-id="${id}"]`);
      this.querySelector('[data-offer-output]').innerHTML = source ? source.innerHTML : '';
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.info?.removeEventListener('change', this.onChange);
    }
  });
}
